import styled from "styled-components";
import Icon from "../icons/Icon";
import { apolloFontFamilyEyebrowSmall, apolloFontSizeEyebrowSmall, apolloFontWeightEyebrowSmall, apolloSpaceInline1HalfX, apolloSpaceInlineHalfX, } from "@nexthink/apollo-tokens";
import { LI_HEIGHT } from "./ActionMenuItem.style";
const ICON_SIZE = 16;
export const StyledIcon = styled(Icon).withConfig({ displayName: "StyledIcon_APC-7281-productShell", componentId: "sc-1789ghl" })({
    "&&": {
        width: `${ICON_SIZE}px`,
    },
    color: "inherit",
    marginRight: apolloSpaceInlineHalfX,
    height: "auto",
});
export const StyledActionMenuHeaderLi = styled.div.withConfig({ displayName: "StyledActionMenuHeaderLi_APC-7281-productShell", componentId: "sc-8q5asd" })(({ theme }) => ({
    whiteSpace: "nowrap",
    color: theme.colors.apolloColorTextPopoverSecondary,
    fontFamily: apolloFontFamilyEyebrowSmall,
    fontSize: apolloFontSizeEyebrowSmall,
    fontWeight: apolloFontWeightEyebrowSmall,
    lineHeight: LI_HEIGHT,
    height: LI_HEIGHT,
    padding: `0 ${apolloSpaceInline1HalfX}`,
    textTransform: "uppercase",
    "& > span": {
        display: "inline-flex",
        position: "relative",
        alignItems: "center",
    },
}));
//# sourceMappingURL=ActionMenuHeader.style.js.map